import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { Dot as BaseDot } from '../icons';
import { grey75, grey25 } from '@zocdoc/branding/colors';

const Dot = styled(BaseDot)`
    display: inline-block;
    font-size: 6px;
    margin: 0 2px;
`;

class BreadcrumbDots extends PureComponent {
    static propTypes = {
        numberOfDots: PropTypes.number.isRequired,
        activeDotIndex: PropTypes.number.isRequired,
    };

    render() {
        const { numberOfDots, activeDotIndex, ...props } = this.props;

        const dots = [];
        let i;

        for (i = 0; i < numberOfDots; i++) {
            dots.push(
                <Dot
                    key={i}
                    color={i === activeDotIndex ? grey75 : grey25}
                    data-test="breadcrumb-dot"
                />
            );
        }

        return (
            <div
                data-test="breadcrumb-dots"
                {...props}
            >
                {dots}
            </div>
        );
    }
}

export {
    BreadcrumbDots as default,
    BreadcrumbDots,
};
